import React, { createContext, useContext, useState, useEffect  } from 'react';
import { useAuth } from './AuthContext';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkTheme, setDarkTheme] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      //  Loads the user's preferred theme at login
      setDarkTheme(user.preferredTheme === 'dark');
    }
  }, [user]);

  const toggleTheme = () => setDarkTheme((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ darkTheme, toggleTheme, setDarkTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);